<template>
<div id="app">
    <transition>
        <!-- <router-view></router-view> -->
        <keep-alive include="search_special">
            <router-view></router-view>
        </keep-alive>
        <!-- <router-view></router-view>
       -->

    </transition>
</div>
</template>

<script>
/*import Vue from 'vue'
	Vue.use(vant);*/

export default {
    name: "app",
    computed: {
        key() {
            return this.$route.name !== undefined ?
                this.$route.name + new Date() :
                this.$route + new Date();
        },
    },
    mounted() {
        let router = this.$route
        let href = location.href
        let test1 = href.indexOf('session.php')
        let test2 = href.indexOf('search_special.php')
        let test3 = href.indexOf('search_auction.php')
        let test4 = href.indexOf('sendInfor.php')
        let test5 = href.indexOf('privacy.php')
        let test6 = href.indexOf('privacy.php?auth=1')
        let test7 = href.indexOf('androidSdk.php')
        let test8 = href.indexOf('androidTuluUserAgreement.php')
        let test9 = href.indexOf('company.php')
        let test10 = href.indexOf('tool.php')
        let test11 = href.indexOf('privacy.php?service=1')
        let locationData = this.search2JSON(href)
        if (test1 != -1) {
            location.href = 'https://m-auction.artron.net/session/' + locationData.sessionCode
        }
        if (test2 != -1) {
            location.href = 'https://m-auction.artron.net/special/' + locationData.specialcode
        }
        if (test3 != -1) {
            location.href = 'https://m-auction.artron.net/trade/auction/detail/' + locationData.artcode
        }
        if (test4 != -1) {
            location.href = 'https://m-auction.artron.net/sendInfor'
        }
        if (test5 != -1) {
            if (test6 != -1) {
                location.href = 'https://m-auction.artron.net/privacy?auth=1'
            } else if (test11 !== -1) {
                location.href = 'https://m-auction.artron.net/privacy?service=1'
            } else {
                location.href = 'https://m-auction.artron.net/privacy'
            }
        }
        if (test7 != -1) {
            location.href = 'https://m-auction.artron.net/androidSdk'
        }
        if (test8 != -1) {
            location.href = 'https://m-auction.artron.net/androidTuluUserAgreement'
        }
        if (test9 != -1) {
            location.href = 'https://m-auction.artron.net/organ/' + locationData.organCode
        }
        if (test10 != -1) {
            location.href = 'https://m-auction-old.artron.net' + location.pathname + location.search
        }
        if (/Android|HarmonyOSWebView|Harmony|webOS|ios|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
            return
        } else {
            let fromLink = ''
            let pcFlag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|HarmonyOS|OpenHarmony|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? false : true;
            if (this.$route.query.from) {
                fromLink = '?from=' + this.$route.query.from
            }
            switch (router.name) {
                case 'home':
                    window.location.href = 'https://auction.artron.net/'
                    break
                case 'session':
                    window.location.href = 'https://auction.artron.net/meeting_detail/' + router.params.sessionCode + fromLink
                    break
                case 'search_special':
                    window.location.href = 'https://auction.artron.net/special_detail/' + router.params.specialCode + fromLink
                    break
                case 'meetinglist':
                    window.location.href = 'https://auction.artron.net/org_detail/' + router.params.organCode
                    break
                case 'productdetail':
                  
                    if (pcFlag) {
                        window.location.href = "https://auction.artron.net/paimai-" + router.params.id + fromLink
                    } else {
                        window.location.href = 'https://m-auction.artron.net/trade/auction/detail/' + router.params.id + fromLink
                    }

                    break
            }
        }
    },
    methods: {
        search2JSON(url) {
            url = url.replace('https://m-auction.artron.net/'); //获取url中"?"符后的字串
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var a = url.indexOf("?")
                var str = url.substr(a);
                str = str.replace('?', '')
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
    }
};
</script>

<style>
@import "./assets/css/index.css"
/* #app {

font-family: 'Avenir', Helvetica, Arial, sans-serif;

-webkit-font-smoothing: antialiased;

-moz-osx-font-smoothing: grayscale;

text-align: center;

color: #2c3e50;

height:100%;
	}
	body,html{

font-size:12px;

height:100%;
	}
	* {

padding: 0;

margin: 0;

max-width:100%;
	}
	input {

border: none;

outline: none;

-webkit-appearance: none;
	}
	ul,
	ol {

list-style: none;
	}
	.f_left {

float: left;
	}

.f_right {

float: right;
	}
	.clearfix::before,
	.clearfix::after {

content: "";

height: 0;

line-height: 0;

display: block;

visibility: hidden;

clear: both;
	} */
</style>
